/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { PriceRequestDetailsFragmentDoc } from './PriceRequestDetailsFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type IPriceRequestsQueryVariables = Types.Exact<{
  isTestQuote?: Types.Maybe<Types.Scalars['Boolean']>
  externalId?: Types.Maybe<Types.Scalars['String']>
  priceRequestId?: Types.Maybe<Types.Scalars['ID']>
  first?: Types.Maybe<Types.Scalars['Int']>
  last?: Types.Maybe<Types.Scalars['Int']>
  before?: Types.Maybe<Types.Scalars['String']>
  after?: Types.Maybe<Types.Scalars['String']>
  sortBy?: Types.Maybe<Types.Scalars['String']>
  createdBy?: Types.Maybe<Array<Types.Scalars['String']> | Types.Scalars['String']>
  equipmentParentId?: Types.Maybe<Array<Types.Scalars['ID']> | Types.Scalars['ID']>
  createdStartDate?: Types.Maybe<Types.Scalars['ISO8601Date']>
  createdEndDate?: Types.Maybe<Types.Scalars['ISO8601Date']>
  shipperApplicationId?: Types.Maybe<Types.Scalars['ID']>
  pickupCity?: Types.Maybe<Types.Scalars['String']>
  pickupStateCode?: Types.Maybe<Types.Scalars['String']>
  deliveryCity?: Types.Maybe<Types.Scalars['String']>
  deliveryStateCode?: Types.Maybe<Types.Scalars['String']>
  pickupRange?: Types.Maybe<Types.Scalars['Int']>
  deliveryRange?: Types.Maybe<Types.Scalars['Int']>
  isMultiStop?: Types.Maybe<Types.Scalars['Boolean']>
  dropType?: Types.Maybe<Array<Types.Scalars['String']> | Types.Scalars['String']>
  sortDirection?: Types.Maybe<Types.ISortOrderEnum>
}>

export type IPriceRequestsQuery = { __typename?: 'Query' } & {
  priceRequests: { __typename?: 'PriceRequestConnection' } & Pick<
    Types.IPriceRequestConnection,
    'totalCount'
  > & {
      pageInfo: { __typename?: 'PageInfo' } & Pick<
        Types.IPageInfo,
        'endCursor' | 'hasNextPage' | 'hasPreviousPage' | 'startCursor'
      >
      edges?: Types.Maybe<
        Array<
          Types.Maybe<
            { __typename?: 'PriceRequestEdge' } & Pick<Types.IPriceRequestEdge, 'cursor'> & {
                node?: Types.Maybe<
                  { __typename?: 'PriceRequest' } & Pick<
                    Types.IPriceRequest,
                    | 'id'
                    | 'additionalStops'
                    | 'createdAt'
                    | 'customerQuote'
                    | 'customerQuoteType'
                    | 'deliveryCity'
                    | 'deliveryDropTrailer'
                    | 'deliveryStartDate'
                    | 'deliveryStartTime'
                    | 'deliveryStateCode'
                    | 'deliveryZipcode'
                    | 'equipmentId'
                    | 'externalId'
                    | 'isTestQuote'
                    | 'isDrop'
                    | 'pickupCity'
                    | 'pickupDropTrailer'
                    | 'pickupStartDate'
                    | 'pickupStartTime'
                    | 'pickupStateCode'
                    | 'pickupZipcode'
                    | 'shipperApplicationId'
                    | 'shipperMiles'
                    | 'source'
                    | 'isDoNotBidApplied'
                    | 'updatedAt'
                  > & {
                      premiums?: Types.Maybe<
                        { __typename?: 'PriceRequestPremium' } & Pick<
                          Types.IPriceRequestPremium,
                          'commodity' | 'quoteWithFuel' | 'quoteWithoutFuel'
                        >
                      >
                      pricingResponse?: Types.Maybe<
                        { __typename?: 'PricingResponse' } & Pick<
                          Types.IPricingResponse,
                          | 'datMiles'
                          | 'datRate'
                          | 'highDatRate'
                          | 'lowDatRate'
                          | 'tcm50'
                          | 'tcm40'
                          | 'tcm75'
                          | 'tcm25'
                        >
                      >
                      shipperApplication?: Types.Maybe<
                        { __typename?: 'ShipperApplication' } & Pick<
                          Types.IShipperApplication,
                          'id' | 'name'
                        >
                      >
                      requestedBy?: Types.Maybe<
                        { __typename?: 'User' } & Pick<
                          Types.IUser,
                          'firstName' | 'lastName' | 'id' | 'userType'
                        >
                      >
                    }
                >
              }
          >
        >
      >
    }
}

export const PriceRequestsDocument = gql`
  query PriceRequests(
    $isTestQuote: Boolean
    $externalId: String
    $priceRequestId: ID
    $first: Int
    $last: Int
    $before: String
    $after: String
    $sortBy: String
    $createdBy: [String!]
    $equipmentParentId: [ID!]
    $createdStartDate: ISO8601Date
    $createdEndDate: ISO8601Date
    $shipperApplicationId: ID
    $pickupCity: String
    $pickupStateCode: String
    $deliveryCity: String
    $deliveryStateCode: String
    $pickupRange: Int
    $deliveryRange: Int
    $isMultiStop: Boolean
    $dropType: [String!]
    $sortDirection: SortOrderEnum = DESC
  ) {
    priceRequests(
      isTestQuote: $isTestQuote
      externalId: $externalId
      priceRequestId: $priceRequestId
      first: $first
      last: $last
      before: $before
      after: $after
      sortBy: $sortBy
      createdBy: $createdBy
      equipmentParentId: $equipmentParentId
      createdStartDate: $createdStartDate
      createdEndDate: $createdEndDate
      shipperApplicationId: $shipperApplicationId
      pickupCity: $pickupCity
      pickupStateCode: $pickupStateCode
      deliveryCity: $deliveryCity
      deliveryStateCode: $deliveryStateCode
      pickupRange: $pickupRange
      deliveryRange: $deliveryRange
      isMultiStop: $isMultiStop
      dropType: $dropType
      sortDirection: $sortDirection
    ) {
      totalCount
      pageInfo {
        endCursor
        hasNextPage
        hasPreviousPage
        startCursor
      }
      edges {
        cursor
        node {
          ...PriceRequestDetails
        }
      }
    }
  }
  ${PriceRequestDetailsFragmentDoc}
`

/**
 * __usePriceRequestsQuery__
 *
 * To run a query within a React component, call `usePriceRequestsQuery` and pass it any options that fit your needs.
 * When your component renders, `usePriceRequestsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = usePriceRequestsQuery({
 *   variables: {
 *      isTestQuote: // value for 'isTestQuote'
 *      externalId: // value for 'externalId'
 *      priceRequestId: // value for 'priceRequestId'
 *      first: // value for 'first'
 *      last: // value for 'last'
 *      before: // value for 'before'
 *      after: // value for 'after'
 *      sortBy: // value for 'sortBy'
 *      createdBy: // value for 'createdBy'
 *      equipmentParentId: // value for 'equipmentParentId'
 *      createdStartDate: // value for 'createdStartDate'
 *      createdEndDate: // value for 'createdEndDate'
 *      shipperApplicationId: // value for 'shipperApplicationId'
 *      pickupCity: // value for 'pickupCity'
 *      pickupStateCode: // value for 'pickupStateCode'
 *      deliveryCity: // value for 'deliveryCity'
 *      deliveryStateCode: // value for 'deliveryStateCode'
 *      pickupRange: // value for 'pickupRange'
 *      deliveryRange: // value for 'deliveryRange'
 *      isMultiStop: // value for 'isMultiStop'
 *      dropType: // value for 'dropType'
 *      sortDirection: // value for 'sortDirection'
 *   },
 * });
 */
export function usePriceRequestsQuery(
  baseOptions?: Apollo.QueryHookOptions<IPriceRequestsQuery, IPriceRequestsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useQuery<IPriceRequestsQuery, IPriceRequestsQueryVariables>(
    PriceRequestsDocument,
    options
  )
}
export function usePriceRequestsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<IPriceRequestsQuery, IPriceRequestsQueryVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useLazyQuery<IPriceRequestsQuery, IPriceRequestsQueryVariables>(
    PriceRequestsDocument,
    options
  )
}
export type PriceRequestsQueryHookResult = ReturnType<typeof usePriceRequestsQuery>
export type PriceRequestsLazyQueryHookResult = ReturnType<typeof usePriceRequestsLazyQuery>
export type PriceRequestsQueryResult = Apollo.QueryResult<
  IPriceRequestsQuery,
  IPriceRequestsQueryVariables
>
